export default "__VITE_ASSET__DPCpocni__"